export default class ClientUserError extends Error {
  type: string;
  code: string;
  constructor(baseError: any) {
    super(baseError.message);
    Error.captureStackTrace(this, ClientUserError);
    this.constructor = ClientUserError;
    (this as any).__proto__ = ClientUserError.prototype;
    this.type = "USER";
    this.name = "UserError";
    this.code = baseError.code;
  }
}
